import React from 'react';

/**
 * 🖊️ Line-icon set (places-nav v3, Nina 08-01 — mock artifact = contract).
 * One 1.6px-stroke language for the app's CHROME: bottom tabs, the ＋ tray's
 * verbs, the poke button. Emoji stays where it's CONTENT (ghost tab, hearts,
 * tea, chips) and leaves where it's a control. All glyphs share a 16-unit
 * viewBox and inherit color via currentColor so active/glow states keep
 * working through the parent's color + filter.
 */
const PATHS = {
  doodle: <path d="M2 12 C5 4, 9 15, 14 6" />,
  upload: <path d="M8 11V3M5 6l3-3 3 3M3 13h10" />,
  // a literal slash — it teaches the typed / shortcut
  actions: <path d="M10 2 6 14" />,
  shelf: <path d="M2 6h12M2 6v7h12V6M6 6v7M10 6v7M4 6V3.5h8V6" />,
  // a nudge: arrow tapping a dot
  poke: <><path d="M2.5 8h7M7 5.5 9.5 8 7 10.5" /><circle cx="12.6" cy="8" r="1.6" /></>,
  chat: <path d="M2.5 5A1.5 1.5 0 0 1 4 3.5h8A1.5 1.5 0 0 1 13.5 5v4.5A1.5 1.5 0 0 1 12 11H7.2l-2.9 2.6V11H4a1.5 1.5 0 0 1-1.5-1.5z" />,
  tv: <><rect x="2" y="4.5" width="12" height="8" rx="1.5" /><path d="M5.5 1.5 8 4.5l2.5-3" /></>,
  locals: <><circle cx="5.7" cy="5.6" r="2.1" /><circle cx="10.9" cy="6.2" r="1.7" /><path d="M2.4 13c0-2.4 1.8-3.7 3.3-3.7s3.3 1.3 3.3 3.7M9.8 13c0-1.9 1.1-3 2.2-3s2.2 1.1 2.2 3" /></>,
  arcade: <><rect x="1.8" y="5" width="12.4" height="6.6" rx="3.3" /><path d="M5.2 6.8v3M3.7 8.3h3" /><circle cx="10.7" cy="7.3" r="0.55" /><circle cx="12.1" cy="9" r="0.55" /></>,
  // a cutesy ghost: rounded head, wavy hem, dot eyes (lane tabs, Nina 08-02)
  ghost: <><path d="M3.2 7.4a4.8 4.8 0 0 1 9.6 0v5.3l-1.6-1.2-1.6 1.2-1.6-1.2-1.6 1.2-1.6-1.2-1.6 1.2z" /><circle cx="6.3" cy="7.6" r="0.55" /><circle cx="9.7" cy="7.6" r="0.55" /></>,
  // the chat bubble whispering: three low dots inside (desktop tab parity, 08-02)
  whisper: <><path d="M2.5 5A1.5 1.5 0 0 1 4 3.5h8A1.5 1.5 0 0 1 13.5 5v4.5A1.5 1.5 0 0 1 12 11H7.2l-2.9 2.6V11H4a1.5 1.5 0 0 1-1.5-1.5z" /><circle cx="5.4" cy="7.3" r="0.55" /><circle cx="8" cy="7.3" r="0.55" /><circle cx="10.6" cy="7.3" r="0.55" /></>,
  // case-file folder with a paper line (desktop Dossier tab parity, 08-03)
  dossier: <><path d="M1.8 12.5V4.2a1 1 0 0 1 1-1h3.3l1.4 1.6h5.7a1 1 0 0 1 1 1v6.7a1 1 0 0 1-1 1H2.8a1 1 0 0 1-1-1z" /><path d="M4.6 9.6h6.8" /></>,
};

const LineIcon = ({ name, size = 17, strokeWidth = 1.6, style }) => (
  PATHS[name] ? (
    <svg
      viewBox="0 0 16 16"
      width={size}
      height={size}
      aria-hidden
      focusable="false"
      style={{
        display: 'block',
        stroke: 'currentColor',
        strokeWidth,
        fill: 'none',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        ...style,
      }}
    >
      {PATHS[name]}
    </svg>
  ) : null
);

export default LineIcon;
